import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestConfig } from '../shared/rest/rest.request';
import { RequestMethod, RequestOptions } from '@angular/http';
import { CustomHttp } from '../common/http/custom.http';
import { es_ES, NzI18nService } from 'ng-zorro-antd';
import Any = jasmine.Any;
import { HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {
  private GET_USER_INFO = new RequestConfig('FOLIO01', 'application/json', true, RequestMethod.Get, '/users/userInfo/{idUser}');
  private DELETE_USER_INFO = new RequestConfig('FOLIO02', 'application/json', true, RequestMethod.Delete, '/users/device/{idUserDevice}');
  private GET_LIST_USER_INFO = new RequestConfig('FOLIO03', 'application/json', true, RequestMethod.Post, '/users/searchUserDevices');
  private UPDATE_USER_INFO = new RequestConfig('FOLIO04', 'application/json', true, RequestMethod.Put, '/users/updateUserDevice');

  constructor(
    private http: CustomHttp,
    private i18n: NzI18nService) {
      this.i18n.setLocale(es_ES);
    }

  getUserInfo(idUser: string): Observable<any> {
    return this.http.sendRequest(this.GET_USER_INFO, null, idUser)
        .map(res => res.json())
        .catch(error => this.http.handleError(error));
  }  

  DeleteUserInfo(idUserDevice: string): Observable<any> {
    return this.http.sendRequest(this.DELETE_USER_INFO, null, idUserDevice)
        .map(res => res)
        .catch(error => this.http.handleError(error));
  }

  getListUserInfo(params: string): Observable<any> {
    this.GET_LIST_USER_INFO.uri = '/users/searchUserDevices' ;
    return this.http.sendRequest(this.GET_LIST_USER_INFO, params,params)
        .map(res => res.json())
        .catch(error => this.http.handleError(error));
  } 

  UpdateUserInfo(data: any): Observable<any> {
    return this.http.sendRequest(this.UPDATE_USER_INFO,data,data)
        .map(res => res)
        .catch(error => this.http.handleError(error));
  }

  
}

export class UserInfoDevice {
  idUserDevice: any;
  idUser: any;
  username: any;
  sucursal: any;
  uuid: any;
  model: any;
  platform: any;
  version: any;
  manufacture: any;
  latitude: any;
  longitude: any;
  enable: any;
  expired_date: any;
}

export class AdvanceSearch {
  sucursal: any;
  suscriptor: number;
  pagina: number;
  cantidad: number;
  desdeFecha: any;
  hastaFecha: any;
  cuadrilla: string;
  order? : String;
  orderType? : String;
  estatus:any;
  id_docto:string;
  uuid: string;
}
